module.exports = __webpack_public_path__ + "static/media/Lauren Dollerschell Headshot.c0233e17.jpg";